const sectionsMultiInfo = document.querySelectorAll('.section-multi-info');

sectionsMultiInfo.forEach(sectionsMultiInfo => {
    let tabTitles = [...sectionsMultiInfo.querySelectorAll('.tab__title')];
    let tabTitleActives = tabTitles.filter((element) => element.classList.contains('active'));
    let tabContents = [...sectionsMultiInfo.querySelectorAll('.tab__content')];
    let tabContentActives = tabContents.filter((element) => element.classList.contains('active'));

    tabTitles.forEach((tab) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            tabTitleActives.forEach((tabActive) => tabActive.classList.remove('active'));
            tabTitleActives = tabTitles.filter((element) => element.dataset.value == `${tab.dataset.value}`);
            tabTitleActives.forEach((tabActive) => tabActive.classList.add('active'))

            tabContentActives.forEach((tabContentActive) => tabContentActive.classList.remove('active'));
            tabContentActives = tabContents.filter((element) => element.dataset.contentValue == `${tab.dataset.value}`);
            tabContentActives.forEach((tabContentActive) => tabContentActive.classList.add('active'))
        });
    })
});
